import { Link } from 'react-router-dom'
import MaintenanceImage from '../../../../assets/maintenance/maintenance-image'
import { Container, Content } from './styles'
import MaintenanceImageDark from '../../../../assets/maintenance/maintenance-image-dark'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import { TFeatureFlags } from '../../../../store/modules/posthog/types'
import { getData } from './data'

const MaintenanceContent = (props: { featureFlag: TFeatureFlags }) => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode)

  const { title, content } = getData(props.featureFlag)

  return (
    <Container>
      <Content>
        {isDarkMode ? (
          <MaintenanceImageDark className="svg-image" />
        ) : (
          <MaintenanceImage className="svg-image" />
        )}

        <div className="group">
          <h1 className="title">{title}</h1>
          <p className="description">{content}</p>

          <Link to="/" className="link-button">
            Voltar para a home
          </Link>
        </div>
      </Content>
    </Container>
  )
}

export default MaintenanceContent
